module.exports = __webpack_public_path__ + "img/NYC Bingo.596ad5bf.jpeg";